/**
 * Pied de page
 * Contient des liens
 */

import React from "react";
import { Link } from "@reach/router";
import { useUrl } from "@utils/navigation";
import { openCookiePopup } from "@components/CookieConsent";
import { useI18n } from "../../I18nextProvider";

const Footer = () => {
  const i18n = useI18n();

  const politiquesUrl = useUrl({ type: "politiques" });
  const creditsUrl = useUrl({ type: "credits" });
  const planUrl = useUrl({ type: "plan" });
  const commentairesUrl = useUrl({ type: "commentaires" });
  const introUrl = useUrl({ type: "intro" });

  const currentDate = new Date();
  const year = `${currentDate.getFullYear()}`;

  return (
    <footer>
      <div>
        <ul>
          <li>
            <Link to={planUrl}>{i18n.t("plan.title")}</Link>
          </li>
          <li>
            <Link to={commentairesUrl}>{i18n.t("commentaires.title")}</Link>
          </li>
        </ul>
        <ul>
          <li>
            <Link to={creditsUrl}>{i18n.t("credits.title")}</Link>
          </li>
          <li>
            <Link to={introUrl}>{i18n.t("intro.title")}</Link>
          </li>
        </ul>
        <ul className="menuFooterSecondaire">
          <li>
            <Link to={politiquesUrl}>{i18n.t("politique.title")}</Link>
          </li>
          {typeof document !== "undefined" && (
            <li>
              <a href="#" onClick={openCookiePopup}>
                {i18n.t("cookieConsent.edit")}
              </a>
            </li>
          )}
        </ul>
        <p>
          © {year} {i18n.t("global.copyright")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
